var React = require('react');

function IconBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.5,49.8L83.6,100l-17.1,0L16.4,49.9L66.5,0l16.7,0L33.5,49.8z"}));
}

IconBack.defaultProps = {"className":"icon back","viewBox":"0 0 100 100"};

module.exports = IconBack;

IconBack.default = IconBack;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-back.svg
// module id = 521
// module chunks = 0